<template>
  <ion-page>
    <ion-content>
      <partials-steps steps="5" active="3" :headline="$t('woodBasedPanel.woodBasedPanels.headline')"></partials-steps>
      <ion-grid>
        <ion-col>
          {{ $t('woodBasedPanel.woodBasedPanels.select.title') }}:
        </ion-col>

        <ion-row v-for="value in values" :key="value.id">
          <ion-col>
            <label :for="value.replace(/\s+/g, '')" class="btn-clickable">
              <ion-col>
                {{ translationMapping[value] ?? value}}
              </ion-col>
              <input :id="value.replace(/\s+/g, '')" v-model="plattenunterart" @click="changePage()" type="radio" :value="value">
            </label>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col>
            <div class="hinweis">
              <b>{{ $t('general.information') }}:</b> {{ $t('woodBasedPanel.woodBasedPanels.information.content') }}
            </div>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col class="btn-back" mode="ios">
            <ion-button @click="goBack()">{{ $t('general.back') }}</ion-button>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script>
import {
  IonContent,
  IonPage,
  IonButton,
  IonGrid,
  IonRow,
  IonCol,
} from '@ionic/vue';
import {defineComponent} from 'vue';
import {store} from "@/store/formtemplate";
import partialsSteps from "@/views/partials/steps";
import {holzhws} from "@/store/holzhws";


export default defineComponent({
  name: 'Holzwerkstoffplatten',
  components: {
    IonContent,
    IonPage,
    IonButton,
    IonGrid,
    IonRow,
    IonCol,
    partialsSteps
  },
  computed: {
    plattenunterart: {
      get() {
        return store.getters.getByProperty("plattenunterart")
      },
      set(value) {
        store.commit("set", {property: 'plattenunterart', value: value});
      }
    },
    values: {
      get() {
        const filtered = holzhws.getters.getFilterd;

        return [...new Set(filtered.map(item => item.plattenunterart))];
      }
    },
    translationMapping: {
      get() {
        const filtered = holzhws.getters.getFilterd;
        const filteredData = [];

        filtered.forEach((obj) => {
          filteredData[obj.plattenunterart] = obj.plattenunterart_translated;
        });

        return filteredData;
      }
    }
  },
  methods: {
    changePage: function () {
      this.$router.push("/Holzwerkstoffplatte/Plattendicke");
    },

    goBack: function () {
      store.commit("set", {property: 'plattenunterart', value: ""});
      store.commit("set", {property: 'plattenart', value: ""});

      this.$router.back();
    }
  }
});
</script>
